var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g-inline-language-select", {
    attrs: { items: _vm.languageOptions, "item-value": "code" },
    model: {
      value: _vm.appLanguage,
      callback: function($$v) {
        _vm.appLanguage = $$v
      },
      expression: "appLanguage"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }